module.exports = __webpack_public_path__ + "media/mypage/images/special/008-cf59dcd3851ffc647fcfed46587fb7ab.jpg";